import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { microAppInitialized } from '@mynexus/mfe-core';

@Component({
    selector: 'app-notes',
    templateUrl: './mnc-notes.component.html',
    styleUrls: ['./mnc-notes.component.scss'],
    standalone: false
})
export class MncNotesComponent implements AfterViewInit {
  constructor(
    private ref: ElementRef,
    private router: Router,
  ) {
    this.router.initialNavigation();
  }

  @Input() set url(value: string){
    this.router.navigate([value]);
  }

  ngAfterViewInit(): void {
    microAppInitialized(this.ref, this.router, 'Notes');
  }
}
